<template>
    <div class="files-container">
        <table class="files-table">
            <thead>
            <tr>
                <th>{{$t("message.name")}}</th>
                <th>{{$t("message.type")}}</th>
                <th>{{$t("message.lastRegulation")}}</th>
                <th>{{$t("message.actions")}}</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="file in files"
                :key="file._id"
            >
                <td>
                    <div>
                        <i :class="getFileIcon(file)" class="file-icon" @click="showViewer(file)"></i>
                        {{ file.name }}
                    </div>
                </td>
                <td>{{ getFileType(file) }}</td>
                <td>{{ formatDate(file.updatedAt) }}</td>
                <td class="actions-column">
                    <button @click="handleDoubleClick(file)" class="action-button open">
                        <span class="md-icon">open_in_new</span>
                    </button>
                    <button @click="deleteFile(file)" class="action-button delete">
                        <span class="md-icon">delete</span>
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

export default {
    name: "FilesView",
    props: {
        files: {
            type: Array,
            default: () => [],
        },
        selectedFiles: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        handleDoubleClick(file) {
            if (file.isFolder) {
                this.$emit("folderDoubleClick", file._id);
            } else if (this.isImage(file)) {
                this.showViewer(file);
            } else {
                this.openFile(file);
            }
        },
        getFileIcon(file) {
            if (file.isFolder) return "fas fa-folder";
            if (this.isImage(file)) return "fas fa-file-image";
            if (file.asset?.mime?.includes("pdf")) return "fas fa-file-pdf";
            return "fas fa-file";
        },
        getFileType(file) {
            if (file.isFolder) return "Klasör";
            if (file.asset?.mime) return file.asset.mime.split("/")[1].toUpperCase();
            return "Dosya";
        },
        isImage(file) {
            return file.asset?.mime?.includes("image");
        },
        getFileUrl(file) {
            return file.asset?.cdnUrl || "";
        },
        showViewer(file) {
            const url = this.getFileUrl(file);
            window.open(url, "_blank");
        },
        openFile(file) {
            console.log(`[DRIVE] File opened: ${file.name}`);
            this.$emit("fileOpen", file);
        },
        deleteFile(file) {
            console.log(`[DRIVE] File deleted: ${file.name}`);
            this.$emit("delete", file);
        },
        formatFileSize(size) {
            if (!size) return "N/A";
            const units = ["B", "KB", "MB", "GB"];
            let i = 0;
            while (size >= 1024 && i < units.length - 1) {
                size /= 1024;
                i++;
            }
            return `${size.toFixed(2)} ${units[i]}`;
        },
        formatDate(date) {
            if (!date) return "N/A";
            return new Date(date).toLocaleString();
        },
    },
};
</script>

<style scoped>
.files-container {
    padding: 20px;
}

.files-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #fff;
    border: 1px solid #ddd;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    font-size: 14px;
    table-layout: auto;
}

.files-table thead {
    background-color: #f1f1f1;
}

.files-table th,
.files-table td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

.files-table th {
    font-weight: bold;
    text-transform: uppercase;
}

.files-table tr:hover {
    background-color: #f5f5f5;
}

.files-table tr.selected {
    background-color: #e6f7ff;
}

.file-icon {
    margin-right: 8px;
    cursor: pointer;
}

.actions-column {
    display: flex;
    gap: 10px;
}

.action-button {
    padding: 5px 10px;
    font-size: 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.action-button.open {
    background-color: #1890ff;
    color: white;
}

.action-button.delete {
    background-color: #ff4d4f;
    color: white;
}

.action-button:hover {
    opacity: 0.8;
}
</style>
